<template>
  <v-container fluid class="fill-height" style="min-height: 100vh">
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular v-if="!error" indeterminate color="primary" size="48" />
        <p class="mt-4 font16">{{ error || 'กำลังเข้าสู่ระบบด้วย LINE...' }}</p>
        <v-btn v-if="error" rounded color="primary" class="mt-2" @click="start">ลองอีกครั้ง</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { resolveLoyaltyLiffLoginId, liffLoginForwardQuery, liffLoginRedirectPath } from '@/utils/liffLogin'

export default {
  name: 'LiffLogin',
  data () {
    return {
      error: '',
      shopId: null,
      branchId: null,
      forwardQuery: {}
    }
  },
  async mounted () {
    await this.start()
  },
  methods: {
    ...mapActions('lineStore', ['setProfile']),
    readState () {
      const raw = decodeURIComponent(window.location.search).replace('?liff.state=', '')
      const stateQuery = new URLSearchParams(raw.split('?')[1] || raw.substring(1))
      this.shopId = this.$route.query.shopId || this.$route.query.sourceShopId ||
        stateQuery.get('shopId') || stateQuery.get('sourceShopId') || this.GET_SHOPID()
      this.branchId = this.$route.query.branchId || stateQuery.get('branchId') || null
      const merged = {}
      stateQuery.forEach((value, key) => { merged[key] = value })
      Object.assign(merged, this.$route.query)
      this.forwardQuery = liffLoginForwardQuery(merged)
      if (this.shopId) {
        this.forwardQuery.shopId = this.shopId
        this.setShopId(this.shopId)
      }
      if (this.branchId) {
        this.forwardQuery.branchId = this.branchId
      }
    },
    async start () {
      this.error = ''
      try {
        this.readState()
        if (!this.shopId) {
          this.error = 'ลิงก์ไม่ถูกต้อง ไม่พบรหัสร้านค้า'
          return
        }
        this.$liffId = await resolveLoyaltyLiffLoginId(this.DNS_Migrate, this.shopId) ||
          await this.legacyLiffId()
        await this.$liff.init({ liffId: this.$liffId, withLoginOnExternalBrowser: true })
        if (!this.$liff.isLoggedIn()) {
          await this.$liff.login({ redirectUri: window.location.href })
          return
        }
        const profile = await this.$liff.getProfile()
        profile.pictureUrl = profile.pictureUrl ||
          'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
        await this.setProfile(profile)
        this.goToDestination()
      } catch (err) {
        console.error('LiffLogin', err)
        this.error = (err && err.message) || 'LIFF login failed'
      }
    },
    // Same fallback App.vue uses for shops that have not been migrated yet.
    async legacyLiffId () {
      try {
        const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
        if (Array.isArray(result.data) && result.data[0].liffMainIDLoyalty) {
          return result.data[0].liffMainIDLoyalty
        }
      } catch (err) {
        console.error('LiffLogin lineconfig', err)
      }
      return '1656906322-JN5MM8Ep'
    },
    goToDestination () {
      const path = liffLoginRedirectPath(this.$route.query)
      const query = new URLSearchParams(this.forwardQuery).toString()
      // Full reload on purpose: App.vue only runs its LIFF bootstrap in mounted().
      window.location.replace(path + (query ? '?' + query : ''))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home/LiffLogin.vue